
import {h} from "preact";
import Breakdown from "./Breakdown";
import sumPartsByQuantity from "../sum/partsByQuantity";
import {isOnHold} from "../filters/hold";


export type BreakdownByQuantityProps = {
  part: string
}

export function BreakdownByQuantity(props: BreakdownByQuantityProps) {
  const {part} = props;

  return <Breakdown
    title={`${props.part}`}
    description={ "On Hold, Quantity (no. of items)" }
    filter={(quotes) => quotes.filter(isOnHold)}
    sum={(items) => sumPartsByQuantity(part, items).toString()}
  />
}

export default BreakdownByQuantity;
